import React from 'react';
import { useNavigate } from 'react-router-dom';
import AuthService from '../../modules/Admin/services/AuthService';

export default function SubscriptionInactive() {
  const navigate = useNavigate();

  const handleLogout = () => {
    AuthService.performLogout(navigate);
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #f8fafc 0%, #eef2ff 100%)',
        padding: '24px',
      }}
    >
      <div
        style={{
          maxWidth: '520px',
          width: '100%',
          background: '#fff',
          borderRadius: '16px',
          boxShadow: '0 12px 40px rgba(15, 23, 42, 0.1)',
          padding: '36px 32px',
          textAlign: 'center',
        }}
      >
        <div
          style={{
            width: '64px',
            height: '64px',
            margin: '0 auto 20px',
            borderRadius: '50%',
            background: '#fff7ed',
            color: '#ea580c',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '28px',
          }}
        >
          <i className="fas fa-receipt" />
        </div>
        <h1 style={{ margin: '0 0 12px', fontSize: '24px', color: '#0f172a' }}>
          Subscription inactive
        </h1>
        <p style={{ margin: '0 0 24px', fontSize: '15px', color: '#64748b', lineHeight: 1.6 }}>
          Your agency workspace does not have an active subscription. Please contact your Super Admin
          to renew or assign a plan before you can access the dashboard and other features.
        </p>
        <button
          type="button"
          onClick={handleLogout}
          style={{
            border: 'none',
            borderRadius: '10px',
            padding: '12px 22px',
            background: 'linear-gradient(135deg, #4f46e5, #6366f1)',
            color: '#fff',
            fontWeight: '700',
            fontSize: '14px',
            cursor: 'pointer',
          }}
        >
          <i className="fas fa-sign-out-alt" style={{ marginRight: '8px' }} />
          Sign out
        </button>
      </div>
    </div>
  );
}
